import React, { useRef, useState, useContext, useEffect, useCallback } from "react";
import { Layout, Form as AntForm, Button } from "antd";
import { Modal, OverlayTrigger, Popover, Form, FormControl } from "react-bootstrap";
import { Logo, UserMenu } from "../../components";
import QRCodeEditor from "../qrCodeEditor";
import infoIcon from "../../assets/img/info-blue.svg";
import desktopLogo from "../../assets/img/unitifi-logo.png";
import HeaderBarWrapper from "./index.style";
import Search from "../../assets/img/header-search-icon.svg";
import InvitePractice from "../inviteForm/invitePractice";
import InviteAssessment from "../inviteForm/inviteAssessment";
import InviteClient from "../inviteForm/inviteClient";
import InviteCompanyMember from "../inviteForm/inviteCompanyMember";
import InviteAdvisor from "../inviteForm/inviteAdvisor";
import { Select } from "antd";
import { components } from "react-select";
import AsyncSelect from "react-select/async";
import debounce from "lodash/debounce";
import axios from "axios";
import { apiUrl } from "../../config";
import { SelectMainWrapper, SelectWrapper } from "../../containers/users/signup/select.style";
import { AccountContext } from "../../context/AccountContext";
import { useQuery } from "react-apollo";
import gql from "graphql-tag";
import { validStringExp } from "../../helpers/formatters";
import { encrypt } from "../../utils/crypt";

const convertImageToBase64 = async (url) => {
  try {
    const response = await fetch(url, { mode: "cors" });
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error fetching the image:", error);
    return null;
  }
};
const { Header } = Layout;
const { Option } = Select;

/** Quick Links QR scope: company vs practice vs advisor — mirrors Practice / Advisor "View QR" pages */
const getQrScope = (rolecode) => {
  if (!rolecode) return "company";
  if (rolecode === "CMPYO" || rolecode === "CMPYM") return "company";
  if (rolecode === "PRCTO" || rolecode === "PRCTM") return "practice";
  if (rolecode === "ADVSO" || rolecode === "ADVSM") return "user";
  return "";
};

const HeaderBar = (props) => {
  const {
    history,
    currentPractice,
    currentPortalId,
    user,
    data: { me },
  } = props;

  //const [isPracticeInviteModal, setPracticeInviteModal] = useState(false);
  const { account, isPracticeInviteModal, setPracticeInviteModal, setAdvisorModal, isAdvisorModal, logoUpdate, setOwnerPractice, setLogoUpdate, setInviteModal, isInviteModal, setAssessmentChange } = useContext(AccountContext);
  const [isAssessmentModal, setAssessmentModal] = useState(false);
  const [isClientModal, setClientModal] = useState(false);
  const [isCompanyModal, setCompanyModal] = useState(false);
  const [isQRCodeModal, setQRCodeModal] = useState(false);
  //const [isAdvisorModal, setAdvisorModal] = useState(false);
  const [totalAssessment, setTotalAssessment] = useState(null);
  const [searchText, setSearchText] = useState("");
  //const [searchPage, setSearchPage] = useState("");
  const assessmentRef = useRef();
  const searchRef = useRef();
  const [menuModal, setMenuModal] = useState(false);
  const [select, setSelect] = useState();
  const [exceedalert, setExceedalert] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  
  const [isQRCodeEnabled, setIsQRCodeEnabled] = useState(false);
  const [state, setState] = useState({
    removeQrCodeBehindLogo: false,
    eyecolor_0_outer: "#000000",
    fgColor: "#000000",
    logoPadding: "0",
    enableCORS: false,
    ecLevel: "L",
    size: "320",
    logoWidth: 76,
    logoHeight: 76,
    siteImage: `${process.env.REACT_APP_MEDIA_URL}site-logos/unitifi-qr-default.png`,
    value: "", // Will be set in useEffect when we have logoData
  });
  
  const ref = useRef(null);
  const qrColorRef = useRef(null);
  const borderColorRef = useRef(null);
  

  const qrScope = me ? getQrScope(me.rolecode) : "company";

  const { loading: logoLoading, data: logoData, refetch: portalRefetch } = useQuery(getPortalDetailsQuery, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
    variables: { id: currentPortalId },
    skip: !currentPortalId,
  });
  const { data: qrPracticeData } = useQuery(getPracticeForQrQuery, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
    variables: { id: me && me.practiceid ? Number(me.practiceid) : 0 },
    skip: !me || !me.practiceid || qrScope !== "practice",
  });
  const { data: qrUserData } = useQuery(getUserForQrQuery, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
    variables: { id: me && me.id ? Number(me.id) : 0 },
    skip: !me || !me.id || qrScope !== "user",
  });
  const { loading: logoDetailLoading, data: logoDetail, refetch: logoRefetch } = useQuery(getLogoDetailsQuery, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
    variables: { portalId: currentPortalId, practiceId: me.practiceid, roleCode: me.rolecode },
  });

  // useEffect(() => {
  //   if (logoUpdate) {
  //     portalRefetch();
  //     logoRefetch();
  //   }
  // }, [logoUpdate]);

  // Company-level QR (portal) — CMPYO / CMPYM
  useEffect(() => {
    if (!me || qrScope !== "company") return;
    if (!logoData || !logoData.getPortal) return;
    setIsQRCodeEnabled(true);
    setOwnerPractice({
      ownerPracticeName: logoData.getPortal.ownerPracticeName,
      ownerPracticeId: logoData.getPortal.ownerPracticeId,
      ownerUserId: logoData.getPortal.id,
    });

    const qrCodeIncode = encrypt(`${logoData.getPortal.slug}_${logoData.getPortal.user.id}`);
    const qrCodeUrl = process.env.REACT_APP_URL + "assessment/" + qrCodeIncode;

    const handleQRCodeUpdate = async () => {
      let obj = {
        removeQrCodeBehindLogo: false,
        eyecolor_0_outer: "#000000",
        fgColor: "#000000",
        logoPadding: "0",
        enableCORS: false,
        ecLevel: "L",
        size: "320",
        logoWidth: 76,
        logoHeight: 76,
        siteImage: `${process.env.REACT_APP_MEDIA_URL}site-logos/unitifi-qr-default.png`,
        value: qrCodeUrl,
      };
      if (logoData.getPortal.qrcode) {
        const qrcode = logoData.getPortal.qrcode;
        if (qrcode.siteImage) {
          const img = await convertImageToBase64(qrcode.siteImage);
          obj = { ...qrcode, logoImage: img ? img : qrcode.siteImage, value: qrCodeUrl };
        } else {
          obj = { ...qrcode, value: qrCodeUrl };
        }
      } else {
        const portalLogo = logoData.getPortal.siteLogo;
        const defaultImg = `${process.env.REACT_APP_MEDIA_URL}site-logos/unitifi-qr-default.png`;
        const img = await convertImageToBase64(portalLogo || defaultImg);
        obj = {
          ...obj,
          logoImage: img ? img : defaultImg,
          siteImage: portalLogo ? portalLogo : defaultImg,
          value: qrCodeUrl,
        };
      }
      setState(obj);
    };

    handleQRCodeUpdate().catch((error) => {
      console.error("Error updating QR code:", error);
    });
  }, [logoData, me, qrScope]);

  // Practice-level QR — PRCTO / PRCTM (same as Practice view / qrcode.js)
  useEffect(() => {
    if (!me || qrScope !== "practice") return;
    const getPractice = qrPracticeData && qrPracticeData.getPractice;
    if (!getPractice) return;
    setIsQRCodeEnabled(true);
    setOwnerPractice({
      ownerPracticeName: getPractice.name,
      ownerPracticeId: getPractice.id,
      ownerUserId: getPractice.ownerid,
    });

    const practiceEncoded =
      getPractice.practiceId == me.portalslug
        ? encrypt(`${me.portalslug}_${getPractice.ownerid || me.id}`)
        : encrypt(`${me.portalslug}`) + "/" + encrypt(`${getPractice.practiceId}_${getPractice.ownerid}`);
    const qrCodeUrl = process.env.REACT_APP_URL + "assessment/" + practiceEncoded;

    const handlePracticeQr = async () => {
      const defaultImg = `${process.env.REACT_APP_MEDIA_URL}site-logos/unitifi-qr-default.png`;
      let qrcode = getPractice.qrcode;
      let obj = {
        removeQrCodeBehindLogo: false,
        eyecolor_0_outer: "#000000",
        fgColor: "#000000",
        logoPadding: "0",
        enableCORS: false,
        ecLevel: "L",
        size: "320",
        logoWidth: 76,
        logoHeight: 76,
        siteImage: defaultImg,
        value: qrCodeUrl,
      };
      if (getPractice.practiceId == me.portalslug) {
        if (getPractice.portalqrcode) {
          qrcode = getPractice.portalqrcode;
          if (qrcode.siteImage) {
            const img = await convertImageToBase64(qrcode.siteImage);
            obj = { ...qrcode, logoImage: img ? img : qrcode.siteImage, value: qrCodeUrl };
          } else {
            obj = { ...qrcode, value: qrCodeUrl };
          }
        } else {
          const portalLogo = getPractice.portallogo ? getPractice.portallogo : defaultImg;
          const img = await convertImageToBase64(portalLogo);
          obj = { ...obj, logoImage: img ? img : defaultImg, value: qrCodeUrl };
        }
      } else if (qrcode) {
        if (qrcode.siteImage) {
          const img = await convertImageToBase64(qrcode.siteImage);
          obj = { ...qrcode, logoImage: img ? img : qrcode.siteImage, value: qrCodeUrl };
        } else {
          obj = { ...qrcode, value: qrCodeUrl };
        }
      } else {
        const img = await convertImageToBase64(getPractice.siteLogo ? getPractice.siteLogo : defaultImg);
        obj = {
          ...obj,
          logoImage: img ? img : defaultImg,
          siteImage: getPractice.siteLogo ? getPractice.siteLogo : defaultImg,
          value: qrCodeUrl,
        };
      }
      setState(obj);
    };

    handlePracticeQr().catch((error) => console.error("Error updating practice QR code:", error));
  }, [qrPracticeData, me, qrScope]);

  // Advisor-level QR — ADVSO / ADVSM (same as Advisor view / qrcode.js)
  useEffect(() => {
    if (!me || qrScope !== "user") return;
    const getUser = qrUserData && qrUserData.getUser;
    if (!getUser) return;
    setIsQRCodeEnabled(true);

    const userEncoded =
      encrypt(`${getUser.portalslug}`) +
      "/" +
      encrypt(getUser.practiceslug) +
      "/" +
      encrypt(`${getUser.firstName}-${getUser.lastName}_${getUser.id}`);
    const qrCodeUrl = process.env.REACT_APP_URL + "assessment/" + userEncoded;

    const handleUserQr = async () => {
      const defaultImg = `${process.env.REACT_APP_MEDIA_URL}site-logos/unitifi-qr-default.png`;
      let qrcode = getUser.qrcode;
      let obj = {
        removeQrCodeBehindLogo: false,
        eyecolor_0_outer: "#000000",
        fgColor: "#000000",
        logoPadding: "0",
        enableCORS: false,
        ecLevel: "L",
        size: "320",
        logoWidth: 76,
        logoHeight: 76,
        siteImage: defaultImg,
        value: qrCodeUrl,
      };
      if (qrcode) {
        if (qrcode.siteImage) {
          const img = await convertImageToBase64(qrcode.siteImage);
          obj = { ...qrcode, logoImage: img ? img : qrcode.siteImage, value: qrCodeUrl };
        } else {
          obj = { ...qrcode, value: qrCodeUrl };
        }
      } else {
        let practice = getUser.practices;
        if (practice && practice.length > 0) practice = practice[0];
        const img = await convertImageToBase64(practice && practice.siteLogo ? practice.siteLogo : defaultImg);
        obj = {
          ...obj,
          logoImage: img ? img : defaultImg,
          siteImage: practice && practice.siteLogo ? practice.siteLogo : defaultImg,
          value: qrCodeUrl,
        };
      }
      setState(obj);
    };

    handleUserQr().catch((error) => console.error("Error updating advisor QR code:", error));
  }, [qrUserData, me, qrScope]);

  useEffect(() => {
    if (!logoDetail) return;
    if (!logoDetail.getLogoByRole) {
      setLogoUpdate(desktopLogo);
      return;
    }

    let logo = logoDetail.getLogoByRole.result;
    logo = logo.siteLogo ? logo.siteLogo : desktopLogo;
    setLogoUpdate(logo);
  }, [logoDetail]);

  function onChange(value) {
    setSelect(value);
    if (!currentPractice && !currentPortalId) {
      setMenuModal(true);
      return;
    }
    if (value == "practice") setPracticeInviteModal(true);
    if (value == "assessment") setAssessmentModal(true);
    if (value == "client") setClientModal(true);
    if (value == "advisor") setAdvisorModal(true);
    if (value == "company") setCompanyModal(true);
    if (value == "qr_code") setQRCodeModal(true);
    setSelect(undefined);
  }
  const quickLinkHandler = (e) => {
    // console.log("e", e.target.value);
    let val = e.target.value;
    if (val == "practice") setPracticeInviteModal(true);
    if (val == "assessment") setAssessmentModal(true);
    if (val == "client") setClientModal(true);
    if (val == "advisor") setAdvisorModal(true);
    if (val == "company") setCompanyModal(true);
    if (val == "qr_code") setQRCodeModal(true);
  };
  const assessmentHandler = () => {
    setAssessmentModal(false);
    setTotalAssessment(null);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();

      search();
    }
  };

  const searchHandler = () => {
    search();
  };
  const asyncsearchHandler = (e) => {
    const selectedOption = e.value; // <--- you can get value from object directly
    setSelectedOption(selectedOption);
    if (props.location.pathname.includes("/clients/view/") || props.location.pathname.includes("/clients/view-compare/")) {
      history.push(`/${e.practiceId}/clients/view/${e.value}`);
      return;
    }

    history.push(`${props.location.pathname}?search=${e.label}`);
  };

  const searchClearandler = () => {
    setSearchText("");
  };

  // QR Code functions


  const search = () => {
    if (!currentPractice && !currentPortalId) {
      setMenuModal(true);
      return;
    }
    const isValid = validStringExp(searchText);
    if (isValid.status) return;
    // if (!searchText) return;
    if (props.location.pathname.includes("/practices")) {
      history.push(`/practices?search=${searchText}`);
    } else if (props.location.pathname.includes("/advisors") && me && me.rolecode != "SPR") {
      history.push(`/advisors?search=${searchText}`);
    } else if (props.location.pathname.includes("/clients") && me && me.rolecode != "SPR") {
      history.push(`${props.location.pathname}?search=${searchText}`);
    } else {
      if (!searchText) return;
      history.push(`/search?search=${searchText}`);
    }
  };

  let searchPlaceHolder = "Search for Practice, Advisor, or Client";
  if (props.location.pathname.includes("/practices")) {
    //setSearchPage("practices");
    searchPlaceHolder = "Search for Practice";
  } else if (props.location.pathname.includes("/advisors")) {
    //setSearchPage("advisors");
    searchPlaceHolder = "Search for Advisor";
  } else if (props.location.pathname.includes("/clients")) {
    //setSearchPage("clients");
    searchPlaceHolder = "Search for Client";
  }
  if (me && me.rolecode == "SPR") searchPlaceHolder = `Search for Advisor or Clients`;

  const clientHandler = useCallback(
    debounce((inputText, callback) => {
      clientApiHandler(inputText).then((options) => callback(options));
    }, 1000),
    [props.location]
  );

  const clientApiHandler = async (input) => {
    let result = "";
    if (input.trim().length <= 1) return;
    if (props.location.pathname.includes("/clients")) {
      result = await axios.get(`${apiUrl}/search-client-header/${input}/${currentPortalId}/${me.practiceid}/${me.rolecode}/${me.id}/${me.accountType}`);
    } else if (props.location.pathname.includes("/advisors")) {
      result = await axios.get(`${apiUrl}/search-advisor/${input}/${currentPortalId}/${me.rolecode}/${me.practiceid}/${me.accountType}`);
    } else if (props.location.pathname.includes("/practices")) {
      result = await axios.get(`${apiUrl}/search-practice/${input}/${currentPortalId}/${me.rolecode}/${me.practiceid}`);
    }
    result = result.data;
    if (result.length == 0) return;

    return result.map((data) => ({
      label: data.displayName,
      value: data.id,
      practiceId: data.practiceId ? data.practiceId : "",
    }));
  };
  const popover = (
    <Popover id="popover-basic">
      <Popover.Header as="h3">Team Discounts</Popover.Header>
      <Popover.Body>
        <ul>
          <li>
            <span>25%</span> off for <span>11-50</span> team members
          </li>
          <li>
            <span>30%</span> off for <span>51-100</span> team members
          </li>
          <li>
            <span>40%</span> off for <span>101-250</span> team members
          </li>
          <li>
            <span>60%</span> off for <span>250+</span> team members
          </li>
        </ul>
      </Popover.Body>
    </Popover>
  );

  const Control = ({ children, ...props }) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <SelectMainWrapper>{children}</SelectMainWrapper>
      </components.Option>
    );
  };
  return (
    <HeaderBarWrapper>
      <Header>
        <div className="unitifi-header-wrapper">
          <div className="unitifi-header-logo">{logoDetailLoading == false && <Logo practiceId={props.currentPractice} currentPortalId={props.currentPortalId} logoData={logoData} logoDetail={logoDetail} />}</div>
          <div className="user-menu-item">
            <div className="search-and-select-wrapper">
              {me && me.rolecode != "SPR" && (props.location.pathname.includes("/clients") || props.location.pathname.includes("/advisors") || props.location.pathname.includes("/practices")) ? (
                <>
                  <AsyncSelect
                    components={{ Option: Control }}
                    onKeyDown={(e) => setSearchText(e.target.value)}
                    placeholder={searchPlaceHolder}
                    ref={searchRef}
                    loadOptions={clientHandler}
                    className="unitifi-select-container unitifi-searchfor-client-input-wrapper"
                    classNamePrefix="unitifi-react-select"
                    value={selectedOption}
                    onChange={(e) => asyncsearchHandler(e)}

                    //isDisabled={queryParam.practice_id ? true : false}
                  />
                  <div className="searchAction" onClick={() => searchHandler()}>
                    <img src={Search} />
                  </div>
                </>
              ) : (
                !props.location.pathname.includes("learning-center") &&
                !props.location.pathname.includes("personality-behavior") && (
                  <Form className="">
                    <div className="search-input-wrapper input-group">
                      <i onClick={() => searchHandler()}>
                        <img src={Search} />
                      </i>
                      <svg xmlns="http://www.w3.org/2000/svg" className={`clear-icon  ${searchText == "" ? "d-none" : ""}`} width="17" height="17" viewBox="0 0 384 512" fill="none" onClick={() => searchClearandler()}>
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M17.0392 15.6244C18.2714 14.084 19.0082 12.1301 19.0082 10.0041C19.0082 5.03127 14.9769 1 10.0041 1C5.03127 1 1 5.03127 1 10.0041C1 14.9769 5.03127 19.0082 10.0041 19.0082C12.1301 19.0082 14.084 18.2714 15.6244 17.0392L21.2921 22.707C21.6828 23.0977 22.3163 23.0977 22.707 22.707C23.0977 22.3163 23.0977 21.6828 22.707 21.2921L17.0392 15.6244ZM10.0041 17.0173C6.1308 17.0173 2.99087 13.8774 2.99087 10.0041C2.99087 6.1308 6.1308 2.99087 10.0041 2.99087C13.8774 2.99087 17.0173 6.1308 17.0173 10.0041C17.0173 13.8774 13.8774 17.0173 10.0041 17.0173Z"
                          fill="#ffffff"
                        />
                      </svg>
                      <Form.Control type="search" placeholder={searchPlaceHolder} ref={searchRef} aria-label="Search" onBlur={() => (searchRef.current.value = "")} onChange={(e) => setSearchText(e.target.value)} onKeyDown={(e) => handleKeyDown(e)} />
                      <div className="input-group-append" onClick={() => searchHandler()}>
                        <span className="input-group-text"></span>
                      </div>
                    </div>
                  </Form>
                )
              )}

              {/*<Form.Select aria-label="Default select example" onChange={(e) => quickLinkHandler(e)}>
                <option value="" disabled selected hidden>Quick Links</option>
                <option value="assessment">Send Assessment</option>
                {user && user.accountType == 1 && (
                  <>
                    <option value="practice">Invite Practice Member</option>
                    <option value="advisor">Invite Advisor</option>{" "}
                  </>
                )}
                <option value="client">Invite Client</option>
                </Form.Select>*/}
              <Select style={{ width: 300 }} placeholder="Quick Links" onChange={onChange} value={select}>
                <Option value="assessment" key={3}>
                  Send Assessment Reminder
                </Option>
                {me && me.accountType == 1 && me.isPortalAdmin && (
                  <Option value="company" key={5}>
                    Invite Company Member(s)
                  </Option>
                )}
                {me && ((me.accountType == 1 && me.rolecode != "ADVSO") || (me.accountType == 2 && (me.isPracticeAdmin || me.isPortalAdmin))) && (
                  <Option value="practice" key={1}>
                    Invite Practice Member(s)
                  </Option>
                )}
                {me && (me.accountType == 1 || (me.accountType == 2 && (me.isPracticeAdmin || me.isPortalAdmin || me.isAdvisorAdmin))) && (
                  <Option value="advisor" key={2}>
                    Invite Advisor(s)
                  </Option>
                )}
                {me &&
                  <Option value="client" key={4}>
                    Send Assessment
                  </Option>
                }
                {isQRCodeEnabled && (
                  <Option value="qr_code" key={6}>
                    QR Code
                  </Option>
                )}
              </Select>
            </div>
            <UserMenu currentPractice={props.currentPractice} {...props} />
          </div>
        </div>
        <div className="mobile-view-header">
            <div className="search-and-select-wrapper">
              {me && me.rolecode != "SPR" && (props.location.pathname.includes("/clients") || props.location.pathname.includes("/advisors") || props.location.pathname.includes("/practices")) ? (
                <>
                  <AsyncSelect
                    components={{ Option: Control }}
                    onKeyDown={(e) => setSearchText(e.target.value)}
                    placeholder={searchPlaceHolder}
                    ref={searchRef}
                    loadOptions={clientHandler}
                    className="unitifi-select-container unitifi-searchfor-client-input-wrapper"
                    classNamePrefix="unitifi-react-select"
                    value={selectedOption}
                    onChange={(e) => asyncsearchHandler(e)}

                    //isDisabled={queryParam.practice_id ? true : false}
                  />
                  <div className="searchAction" onClick={() => searchHandler()}>
                    <img src={Search} />
                  </div>
                </>
              ) : (
                !props.location.pathname.includes("learning-center") &&
                !props.location.pathname.includes("personality-behavior") && (
                  <Form className="">
                    <div className="search-input-wrapper input-group">
                      <i onClick={() => searchHandler()}>
                        <img src={Search} />
                      </i>
                      <svg xmlns="http://www.w3.org/2000/svg" className={`clear-icon  ${searchText == "" ? "d-none" : ""}`} width="17" height="17" viewBox="0 0 384 512" fill="none" onClick={() => searchClearandler()}>
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M17.0392 15.6244C18.2714 14.084 19.0082 12.1301 19.0082 10.0041C19.0082 5.03127 14.9769 1 10.0041 1C5.03127 1 1 5.03127 1 10.0041C1 14.9769 5.03127 19.0082 10.0041 19.0082C12.1301 19.0082 14.084 18.2714 15.6244 17.0392L21.2921 22.707C21.6828 23.0977 22.3163 23.0977 22.707 22.707C23.0977 22.3163 23.0977 21.6828 22.707 21.2921L17.0392 15.6244ZM10.0041 17.0173C6.1308 17.0173 2.99087 13.8774 2.99087 10.0041C2.99087 6.1308 6.1308 2.99087 10.0041 2.99087C13.8774 2.99087 17.0173 6.1308 17.0173 10.0041C17.0173 13.8774 13.8774 17.0173 10.0041 17.0173Z"
                          fill="#ffffff"
                        />
                      </svg>
                      <Form.Control type="search" placeholder={searchPlaceHolder} ref={searchRef} aria-label="Search" onBlur={() => (searchRef.current.value = "")} onChange={(e) => setSearchText(e.target.value)} onKeyDown={(e) => handleKeyDown(e)} />
                      <div className="input-group-append" onClick={() => searchHandler()}>
                        <span className="input-group-text"></span>
                      </div>
                    </div>
                  </Form>
                )
              )}
            </div>
        </div>

      </Header>
      <Modal
        show={isPracticeInviteModal}
        onExited={() => {
          setPracticeInviteModal(false);
          setSelect(undefined);
          setExceedalert(false);
          setInviteModal(null);
        }}
        onHide={() => {
          setPracticeInviteModal(false);
          setSelect(undefined);
          setExceedalert(false);
          setInviteModal(null);
        }}
        centered
        className="unitifi-modal-wrapper notifyBox">
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            Invite Practice Member(s)
            {/* {exceedalert && (
              <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={popover}>
                <i className="ms-2">
                  <img src={infoIcon} />
                </i>
              </OverlayTrigger>
            )} */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InvitePractice
            setPracticeInviteModal={setPracticeInviteModal}
            isInviteModal={isInviteModal}
            setInviteModal={setInviteModal}
            exceedalert={exceedalert}
            setExceedalert={setExceedalert}
            currentPortalId={props.currentPortalId}
            gblUserId={props.gblUserId}
            {...props}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={isAssessmentModal}
        onHide={() => {
          assessmentHandler();
          setSelect(undefined);
        }}
        centered
        size="lg"
        className="unitifi-modal-wrapper modalAssessment">
        <Modal.Header className="p-0">
          {/* <Modal.Title id="example-modal-sizes-title-sm"> Assessment Reminder</Modal.Title> */}
          {totalAssessment && (
            <p className="selectAssessment mb-0" onClick={() => assessmentRef.current.selectAll({ value: 0, label: `Send assessment to all selected (${totalAssessment})` })}>
              Select All({totalAssessment})
            </p>
          )}
        </Modal.Header>
        {/* <Modal.Body> */}
        <InviteAssessment ref={assessmentRef} setAssessmentModal={setAssessmentModal} setTotalAssessment={setTotalAssessment} currentPortalId={props.currentPortalId} gblUserId={props.gblUserId} {...props} me={me} />
        {/* </Modal.Body> */}
      </Modal>

      <Modal
        show={isClientModal}
        onHide={() => {
          setClientModal(false);
          setSelect(undefined);
        }}
        centered
        className="unitifi-modal-wrapper client-modal">
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">Send Assessment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InviteClient setClientModal={setClientModal} currentPortalId={props.currentPortalId} gblUserId={props.gblUserId} setAssessmentChange={setAssessmentChange} {...props} me={me} />
        </Modal.Body>
      </Modal>

      <Modal
        show={isCompanyModal}
        onExited={() => {
          setCompanyModal(false);
          setSelect(undefined);
          setExceedalert(false);
        }}
        onHide={() => {
          setCompanyModal(false);
          setSelect(undefined);
          setExceedalert(false);
        }}
        centered
        className="unitifi-modal-wrapper">
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            Invite Company Member(s)
            {/* {exceedalert && (
              <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={popover}>
                <i className="ms-2">
                  <img src={infoIcon} />
                </i>
              </OverlayTrigger>
            )} */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InviteCompanyMember setCompanyModal={setCompanyModal} exceedalert={exceedalert} setExceedalert={setExceedalert} currentPortalId={props.currentPortalId} gblUserId={props.gblUserId} {...props} me={me} />
        </Modal.Body>
      </Modal>

      <Modal
        show={isAdvisorModal}
        onExited={() => {
          setAdvisorModal(false);
          setSelect(undefined);
          setExceedalert(false);
          setInviteModal(null);
        }}
        onHide={() => {
          setAdvisorModal(false);
          setSelect(undefined);
          setExceedalert(false);
          setInviteModal(null);
        }}
        centered
        className="unitifi-modal-wrapper notifyBox">
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            Invite Advisor(s)
            {/* {exceedalert && (
              <OverlayTrigger trigger="click" rootClose placement="bottom" overlay={popover}>
                <i className="ms-2">
                  <img src={infoIcon} />
                </i>
              </OverlayTrigger>
            )} */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InviteAdvisor
            isInviteModal={isInviteModal}
            setInviteModal={setInviteModal}
            setAdvisorModal={setAdvisorModal}
            exceedalert={exceedalert}
            setExceedalert={setExceedalert}
            currentPortalId={props.currentPortalId}
            me={me}
            gblUserId={props.gblUserId}
            {...props}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={menuModal}
        onHide={() => {
          setMenuModal(false);
          setSelect(undefined);
        }}
        centered
        className="unitifi-modal-wrapper request-modal-wrapper">
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-sm">
            <h4>Thank you for signing up!</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Please be patient while you wait for your organization to accept your request. Feel free to checkout the tools you will receive by joining the Unitifi platform!</p>
          <div className="modal-btn-wrapper">
            <button className="exploreBtn" type="primary" onClick={() => window.open("https://unitifi.com", "_blank")}>
              Explore Our Tools
            </button>
          </div>
          </Modal.Body>
        </Modal>

        <QRCodeEditor
          isOpen={isQRCodeModal}
          onClose={() => setQRCodeModal(false)}
          currentPortalId={currentPortalId}
          gblUserId={props.gblUserId}
          initialState={state}
          onSave={(newState) => setState(newState)}
          me={me}
          account={account}
          qrScope={qrScope}
          practiceId={qrPracticeData && qrPracticeData.getPractice && qrPracticeData.getPractice.id}
          practiceOwnerId={qrPracticeData && qrPracticeData.getPractice && qrPracticeData.getPractice.ownerid}
          userId={me && me.id}
        />
      </HeaderBarWrapper>
    );
  };
export default HeaderBar;

const getPortalDetailsQuery = gql`
  query($id: Int) {
    getPortal(id: $id) {
      id
      name
      siteLogo
      ownerPracticeName
      ownerPracticeId
      qrcode
      slug
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
const getLogoDetailsQuery = gql`
  query($roleCode: String, $practiceId: Int, $portalId: Int) {
    getLogoByRole(roleCode: $roleCode, practiceId: $practiceId, portalId: $portalId) {
      result {
        siteLogo
        siteLogoS3Token
      }
    }
  }
`;

const getPracticeForQrQuery = gql`
  query getPracticeForQr($id: Int!) {
    getPractice(id: $id) {
      id
      name
      practiceId
      siteLogo
      ownerid
      qrcode
      portalqrcode
      portallogo
    }
  }
`;

const getUserForQrQuery = gql`
  query getUserForQr($id: Int!) {
    getUser(id: $id) {
      id
      firstName
      lastName
      portalslug
      practiceslug
      qrcode
      practices
    }
  }
`;
